import { render, staticRenderFns } from "./OrderFinishedScreen.vue?vue&type=template&id=f06cfca6&scoped=true&"
import script from "./OrderFinishedScreen.vue?vue&type=script&lang=js&"
export * from "./OrderFinishedScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06cfca6",
  null
  
)

export default component.exports